// Centralized @font-face registrations for Nitti fonts in @repo/ui
import NNNittiGroteskHeadingEOT from "../assets/font/Nitti/NNNittiGrotesk-Heading.eot";
import NNNittiGroteskHeadingWoff from "../assets/font/Nitti/NNNittiGrotesk-Heading.woff";
import NNNittiGroteskTextBoldEOT from "../assets/font/Nitti/NNNittiGrotesk-TextBold.eot";
import NNNittiGroteskTextBoldWoff from "../assets/font/Nitti/NNNittiGrotesk-TextBold.woff";
import NNNittiGroteskTextMediumEOT from "../assets/font/Nitti/NNNittiGrotesk-TextMedium.eot";
import NNNittiGroteskTextMediumWoff from "../assets/font/Nitti/NNNittiGrotesk-TextMedium.woff";
import NNNittiGroteskTextRegularEOT from "../assets/font/Nitti/NNNittiGrotesk-TextRegular.eot";
import NNNittiGroteskTextRegularWoff from "../assets/font/Nitti/NNNittiGrotesk-TextRegular.woff";

export const fontFaces = `
html {
    overflow-y: scroll;
    font-size: 62.5%;
}

strong {
    font-family: "NNNittiGroteskTextBold";
    font-weight: 600;
}

@font-face {
    font-family: "NNNittiGroteskHeading";
    src: url(${NNNittiGroteskHeadingEOT}) format('eot'), url(${NNNittiGroteskHeadingWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: "NNNittiGroteskTextBold";
    src: url(${NNNittiGroteskTextBoldEOT}) format('eot'), url(${NNNittiGroteskTextBoldWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: "NNNittiGroteskTextMedium";
    src: url(${NNNittiGroteskTextMediumEOT}) format('eot'), url(${NNNittiGroteskTextMediumWoff}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: "NNNittiGroteskTextRegular";
    src: url(${NNNittiGroteskTextRegularEOT}) format('eot'), url(${NNNittiGroteskTextRegularWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
}
`;
